/**
 * Remote-asset fetcher registry (Collab Phase 4).
 *
 * Tiny indirection so the renderer can fall back to a network fetch for
 * pb-asset:// records missing from local IndexedDB WITHOUT ever importing
 * collab code. collab-assets.js installs a fetcher while a shared project is
 * open; solo projects leave it null and the renderer behaves exactly as
 * before (missing record → broken-image handler).
 *
 * Contract: fetcher(id) resolves an asset record `{blob, filename, mime,
 * source, author, authorUrl, hash}` (already persisted to the asset store by
 * the fetcher, with notify:false) or null. It must handle its own in-flight
 * dedupe and negative caching — the renderer calls it once per unresolved id
 * per render pass.
 */

let _fetcher = null;

/** @param {((id:string) => Promise<object|null>)|null} fn */
export function setRemoteAssetFetcher(fn) {
  _fetcher = typeof fn === 'function' ? fn : null;
}

export function getRemoteAssetFetcher() {
  return _fetcher;
}
